export default "__VITE_ASSET__81e14ef4__"